import { render, staticRenderFns } from "./detail_fen.vue?vue&type=template&id=bbb860a2&scoped=true"
import script from "./detail_fen.vue?vue&type=script&lang=js"
export * from "./detail_fen.vue?vue&type=script&lang=js"
import style0 from "./detail_fen.vue?vue&type=style&index=0&id=bbb860a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb860a2",
  null
  
)

/* custom blocks */
import block0 from "./detail_fen.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports